import { SentimentSpeaker } from '@capturi/api-sentiment'
import React from 'react'

export type SpeakerTypes = Exclude<SentimentSpeaker, 'Combined'>

const SpeakerContext = React.createContext<SpeakerTypes>('User')

export default SpeakerContext
